import { Box } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import { ReactComponent as IconEdit } from "assets/svg/20-edit.svg";
import { ReactComponent as IconDelete } from "assets/svg/20-delete.svg";

interface PopoverActionProps {
  showAction: boolean;
  editable: boolean;
  isDeletable?: boolean;
  isCancelable?: boolean;
  cancelAction?: (e) => void;
  editAction: (e) => void;
  deleteAction: (e) => void;
}

export const PopoverAction = ({
  showAction,
  isDeletable,
  editable,
  isCancelable,
  editAction,
  deleteAction,
  cancelAction,
}: PopoverActionProps) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        justifyContent: "center",
        marginLeft: `-${pxToRem(15)}`,
        marginRight: `-${pxToRem(18)}`,
        height: "100%",
        width: `calc(100% + ${pxToRem(32)})`,
        backgroundColor: "white",
        paddingY: 1,
      }}
    >
      {showAction && (
        <>
          {editable && (
            <Box
              display={"flex"}
              alignItems={"center"}
              sx={(theme) => ({
                color: theme.palette.text.textLink,
                cursor: "pointer",
                width: pxToRem(32),
                display: "flex",
                justifyContent: "right",
                height: pxToRem(32),
                background: "transparent",
                svg: {
                  width: pxToRem(16),
                  height: pxToRem(16),
                },
              })}
              onClick={(e) => {
                editAction(e);
              }}
            >
              <IconEdit />
            </Box>
          )}
          {isDeletable && (
            <Box
              display={"flex"}
              alignItems={"center"}
              sx={(theme) => ({
                color: theme.palette.text.textNegative,
                cursor: "pointer",
                width: pxToRem(32),
                height: pxToRem(32),
                display: "flex",
                justifyContent: "left",
                paddingLeft: pxToRem(4),
              })}
              onClick={(e) => {
                deleteAction(e);
              }}
            >
              <IconDelete />
            </Box>
          )}
          {isCancelable && (
            <Box
              display={"flex"}
              alignItems={"center"}
              sx={(theme) => ({
                color: theme.palette.text.textNegative,
                background: theme.palette.background.bgNegativePrimary,
                padding: pxToRem(4),
                paddingX: pxToRem(12),
                borderRadius: pxToRem(4),
                cursor: "pointer",
                fontWeight: theme.typography.fw_semibold_600,
                display: "flex",
                justifyContent: "left",
              })}
              onClick={(e) => {
                cancelAction?.(e);
              }}
            >
              Hủy
            </Box>
          )}
        </>
      )}
    </Box>
  );
};
